import { Component, forwardRef, Inject, Input, Optional } from '@angular/core';
import { Router } from '@angular/router';
import {
  BaseWidget,
  NgAisIndex,
  NgAisInstantSearch
} from 'angular-instantsearch';
import { connectAutocomplete } from 'instantsearch.js/es/connectors';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'front-app-autocompleteSeach',
  templateUrl: './autocompleteSeach.component.html',
  styleUrls: ['./autocompleteSeach.component.scss']
})
export class AutocompleteSeachComponent extends BaseWidget {
  @Input() public attribute: string;
  searchParameters = {
    query: '',
    filters: 'appKey.appKey:' + environment.appKey
  };

  state: {
    query: string;
    refine: Function;
    indices: object[];
  };
  public client: string;
  constructor(
    private router: Router,
    @Inject(forwardRef(() => NgAisIndex))
    @Optional()
    public parentIndex: NgAisIndex,
    @Inject(forwardRef(() => NgAisInstantSearch))
    public instantSearchInstance: NgAisInstantSearch
  ) {
    super('AutocompleteSeachComponent');
  }

  public handleChange($event: KeyboardEvent) {
    this.state.refine(($event.target as HTMLInputElement).value);
  }

  ngOnInit(): void {
    // get client for css
    this.client = `?client=${localStorage.getItem('client')}`;
    this.createWidget(connectAutocomplete, {});
    super.ngOnInit();
  }

  goToDetailOffer(option: any) {
    const titleOffer = option.title.replaceAll(' ', '-').replaceAll('%', '');
    const titleMerchant = option.merchant
      .replaceAll(' ', '-')
      .replaceAll('%', '');
    this.router.navigateByUrl(
      '/webcliente/offer/' +
        option.id +
        '-' +
        titleMerchant +
        '-' +
        titleOffer +
        this.client
    );
  }
}
